/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { LeagueResponse } from './LeagueResponse';
import {
    LeagueResponseFromJSON,
    LeagueResponseFromJSONTyped,
    LeagueResponseToJSON,
    LeagueResponseToJSONTyped,
} from './LeagueResponse';

/**
 * 
 * @export
 * @interface GenerateFixturesResponse
 */
export interface GenerateFixturesResponse {
    /**
     * 
     * @type {LeagueResponse}
     * @memberof GenerateFixturesResponse
     */
    league: LeagueResponse;
    /**
     * 
     * @type {string}
     * @memberof GenerateFixturesResponse
     */
    message?: string;
}

/**
 * Check if a given object implements the GenerateFixturesResponse interface.
 */
export function instanceOfGenerateFixturesResponse(value: object): value is GenerateFixturesResponse {
    if (!('league' in value) || value['league'] === undefined) return false;
    return true;
}

export function GenerateFixturesResponseFromJSON(json: any): GenerateFixturesResponse {
    return GenerateFixturesResponseFromJSONTyped(json, false);
}

export function GenerateFixturesResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GenerateFixturesResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'league': LeagueResponseFromJSON(json['league']),
        'message': json['message'] == null ? undefined : json['message'],
    };
}

export function GenerateFixturesResponseToJSON(json: any): GenerateFixturesResponse {
    return GenerateFixturesResponseToJSONTyped(json, false);
}

export function GenerateFixturesResponseToJSONTyped(value?: GenerateFixturesResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'league': LeagueResponseToJSON(value['league']),
        'message': value['message'],
    };
}

